/* eslint-disable no-console */
import axios from 'axios';

import { envEngine } from '../environments/environment-game-engine';

/**
 * Polls the platform REST API until `/system-health/match-capable` succeeds.
 * Shared by GES startup and local SP hosts (e.g. pixi); not GES-specific.
 */
export class RestServerDiagnostic {
  private static readonly RETRY_INTERVAL: number = 5000;
  private static readonly MAX_ATTEMPTS: number = 10;

  private static _matchCapable?: boolean = undefined;

  public static get matchCapable(): boolean {
    return !!this._matchCapable;
  }

  /**
   * Checks REST server and retries until successful
   * @param interval Milliseconds between retry attempts (default: 5000)
   * @returns Promise that resolves when server is match-capable
   */
  public static async waitUntilMatchCapable(interval: number = this.RETRY_INTERVAL): Promise<void> {
    let attempt = 0;
    while (!this._matchCapable && attempt < this.MAX_ATTEMPTS) {
      attempt++;
      this._matchCapable = await this.checkMatchCapable();
      if (this._matchCapable) { return; }

      console.warn(`REST server not reachable (attempt ${attempt}), retrying in ${interval}ms...`);
      await new Promise((resolve) => setTimeout(resolve, interval));
    }

    if (!this._matchCapable) {
      console.warn(`Failed to establish REST server connection after ${this.MAX_ATTEMPTS} attempts.`);
    }
  }

  private static async checkMatchCapable(): Promise<boolean> {
    try {
      const response = await axios.get<boolean>(`${envEngine.gameAPIEndpoint}/system-health/match-capable`);
      return response.data;
    }
    catch (reason: unknown) {
      console.error(`REST server checkMatchCapable error:`, reason);
      return false;
    }
  }
}
